import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { supabase } from "../providers/supabase/supabase";
import { Input } from "@/components/ds/ui/input";
import { Label } from "@/components/ds/ui/label";
import { Loader2 } from "lucide-react";

export const SetupWorkspace = () => {
  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 👇 ADD THIS CHECK
  useEffect(() => {
    supabase.auth.getUser().then(async ({ data: { user } }) => {
      if (!user) return;
      const { data: sale } = await supabase
        .from("sales")
        .select("org_id")
        .eq("user_id", user.id)
        .maybeSingle();

      // If they already have an org, they shouldn't be here.
      // Send them to the dashboard.
      if (sale?.org_id) {
        window.location.href = "/";
      }
    });
  }, []);

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Button clicked! Starting..."); // 👈 CHECK IF THIS FIRES

    if (!companyName) {
      alert("Please enter a company name");
      return;
    }

    setLoading(true);

    try {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      console.log("User:", user); // 👈 CHECK IF USER EXISTS
      if (!user) throw new Error("No user found - you are not logged in");

      const { data: orgData, error: orgError } = await supabase
        .from("organizations")
        .insert({ name: companyName })
        .select()
        .single();

      if (orgError) {
        console.error("Org creation failed:", orgError);
        throw new Error(orgError.message);
      }

      const { error: salesError } = await supabase
        .from("sales")
        .update({
          org_id: orgData.id,
          administrator: true, // 👈 This is all you need
        })
        .eq("user_id", user.id);

      if (salesError) {
        console.error("Sales update failed:", salesError);
        throw new Error(salesError.message);
      }
      console.log("4. Sales updated! Redirecting...");

      window.location.href = "/";
    } catch (error: any) {
      console.error("Full error:", error);
      alert(error.message || "Failed to create workspace");
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-bold">Welcome to neXus</h1>
          <p className="text-muted-foreground">Let's set up your workspace.</p>
        </div>
        <form
          onSubmit={handleCreate}
          className="space-y-4 border p-6 rounded-lg bg-card"
        >
          <div className="space-y-2">
            <Label htmlFor="company">Company Name</Label>
            <Input
              id="company"
              placeholder="Acme Corp"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </div>
          {/* 👇 SWAPPED TO NATIVE BUTTON FOR TESTING */}
          <button
            type="submit"
            className="w-full inline-flex items-center justify-center rounded-md bg-primary px-8 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 h-10"
            disabled={loading || !companyName}
          >
            {loading ? <Loader2 className="animate-spin h-4 w-4 mr-2" /> : null}
            Create Workspace
          </button>
        </form>
      </div>
    </div>
  );
};